export default Object.freeze([
	{
		label: 'Front Door',
		value: 'FrontDoor',
	},
	{
		label: 'Back Door',
		value: 'BackDoor',
	},
	{
		label: 'Side Door',
		value: 'SideDoor',
	},
	{
		label: 'Knock on Door/Ring Bell',
		value: 'KnockOnDoorRingBell',
	},
	{
		label: 'Mail Room',
		value: 'MailRoom',
	},
	{
		label: 'Office',
		value: 'Office',
	},
	{
		label: 'Reception',
		value: 'Reception',
	},
	{
		label: 'Other',
		value: 'Other',
	},
]);
